import React from "react";
import styles from "./Footer.module.css";

export default function Footer() {
  return <footer className={styles.footer}>© LevelUp Works 2023</footer>;
}
